import React, { Component } from 'react'
import axios from 'axios'
import './ForgotPage.scss'
import { withCookies, Cookies } from 'react-cookie'
import HeaderLogin from '../../Components/Commons/HeaderLogin'

class ForgotPage extends Component {
    constructor(props, context) {
        super(props, context)

        this.state = {
            input: {
                email: '',
            },
            sendMail: false,
            referrer: 'hausplanner',
        }
    }

    UNSAFE_componentWillMount() {
        this.loadCookie()
    }

    loadCookie = () => {
        const appName = this.props.cookies.get('app_name')
        if (appName && appName !== '') {
            this.setState({
                referrer: appName,
            })
        }
    }

    findPassword = (event) => {
        event.preventDefault()

        if (this.state.input.email === '') {
            alert('이메일을 입력해 주세요.')
            return
        }

        axios
            .post(`${BACKEND_HOST}/auth/forgot-password`, {
                email: this.state.input.email.trim(),
                referrer: this.state.referrer,
            })
            .then((res) => {
                console.log(res)
                this.setState({
                    sendMail: true,
                })
            })
            .catch((err) => {
                console.log(err)
            })
    }

    changeData = (event) => {
        const field = event.target.name
        const input = this.state.input
        input[field] = event.target.value

        this.setState({
            input,
        })
    }

    render() {
        console.log(this.state)
        return (
            <div>
                <HeaderLogin />
                <div className="section_wrap">
                    <div className="forgot_wrap common_detail">
                        <div className="forgot_section">
                            <div className="section_top">
                                <h1>비밀번호 찾기</h1>
                            </div>
                            {this.state.sendMail ? (
                                <div className="section_bottom_mail">
                                    <svg
                                        xmlns="http://www.w3.org/2000/svg"
                                        xmlnsXlink="http://www.w3.org/1999/xlink"
                                        width="82"
                                        height="56"
                                        viewBox="0 0 82 56">
                                        <defs>
                                            <radialGradient
                                                id="mail_a"
                                                fx="50%"
                                                fy="50%"
                                                gradientTransform="matrix(0 1 -1.03257 0 1.016 0)">
                                                <stop offset="0%" stopColor="#B0E26A" />
                                                <stop offset="98.894%" stopColor="#C6EA94" />
                                            </radialGradient>
                                            <path
                                                id="mail_c"
                                                d="M2.963 20h72.075a3 3 0 0 1 1.844 5.366L39.001 54.908 1.118 25.366A3 3 0 0 1 2.963 20z"
                                            />
                                            <filter
                                                id="mail_b"
                                                width="110.3%"
                                                height="123.4%"
                                                x="-5.1%"
                                                y="-5.9%"
                                                filterUnits="objectBoundingBox">
                                                <feOffset dy="2" in="SourceAlpha" result="shadowOffsetOuter1" />
                                                <feGaussianBlur
                                                    in="shadowOffsetOuter1"
                                                    result="shadowBlurOuter1"
                                                    stdDeviation="1"
                                                />
                                                <feColorMatrix
                                                    in="shadowBlurOuter1"
                                                    values="0 0 0 0 0.611764706 0 0 0 0 0.764705882 0 0 0 0 0.4 0 0 0 0.15 0"
                                                />
                                            </filter>
                                            <path
                                                id="mail_e"
                                                d="M2.963 0h72.075a3 3 0 0 1 1.844 5.366L42.076 32.51a5 5 0 0 1-6.15 0L1.118 5.366A3 3 0 0 1 2.963 0z"
                                            />
                                            <filter
                                                id="mail_d"
                                                width="109%"
                                                height="120.5%"
                                                x="-4.5%"
                                                y="-7.3%"
                                                filterUnits="objectBoundingBox">
                                                <feOffset dy="1" in="SourceAlpha" result="shadowOffsetOuter1" />
                                                <feGaussianBlur
                                                    in="shadowOffsetOuter1"
                                                    result="shadowBlurOuter1"
                                                    stdDeviation="1"
                                                />
                                                <feColorMatrix
                                                    in="shadowBlurOuter1"
                                                    values="0 0 0 0 0.611764706 0 0 0 0 0.764705882 0 0 0 0 0.4 0 0 0 0.31 0"
                                                />
                                            </filter>
                                        </defs>
                                        <g fill="none" fillRule="evenodd" transform="translate(2 1)">
                                            <rect width="78" height="54" fill="url(#mail_a)" rx="3" />
                                            <g transform="rotate(-180 39 37.075)">
                                                <use fill="#000" filter="url(#mail_b)" xlinkHref="#mail_c" />
                                                <use fill="#D0F996" xlinkHref="#mail_c" />
                                            </g>
                                            <use fill="#000" filter="url(#mail_d)" xlinkHref="#mail_e" />
                                            <use fill="#E7FFC5" xlinkHref="#mail_e" />
                                        </g>
                                    </svg>
                                    <p className="mail_text1">
                                        메일을 발송했습니다.
                                        <br />
                                        메일함을 확인해 주세요!
                                    </p>
                                    <p className="mail_text2">
                                        비밀번호 변경 메일을 계정에 등록된 메일로 보냈습니다.
                                        <br />
                                        메일을 받지 못했다면, 등록하신 메일을 다시 확인하시거나 스팸 메일함을
                                        확인해주세요.
                                    </p>
                                </div>
                            ) : (
                                <form className="section_bottom" action="/" onSubmit={this.findPassword}>
                                    <p className="noti_text">
                                        *가입한 이메일 계정을 입력해주세요!
                                        <br />
                                        비밀번호를 재설정할 수 있도록 메일을 발송합니다.
                                    </p>
                                    <div className="input_wrap">
                                        <label>이메일</label>
                                        <input
                                            className="input"
                                            type="text"
                                            name="email"
                                            onChange={this.changeData}
                                            value={this.state.input.email}
                                        />
                                    </div>
                                    <button
                                        type="submit"
                                        className={
                                            this.state.input.email === '' ? 'full_btn_pc' : 'full_btn_pc btn_active'
                                        }>
                                        비밀번호 재설정
                                    </button>
                                </form>
                            )}
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}

export default withCookies(ForgotPage)



// WEBPACK FOOTER //
// ./Src/Containers/User/ForgotPage.js